export default __webpack_public_path__ + "static/media/flight3.b77c781c.jpg";